import {
  Archive,
  Gift,
  Grid3X3,
  Image,
  Layers,
  Package,
  Printer,
  Signpost,
  Shirt,
  Sofa,
  Sticker,
  Tent,
  Wrench,
  type LucideIcon,
} from 'lucide-react';

const iconMap: Record<string, LucideIcon> = {
  archive: Archive,
  gift: Gift,
  grid: Grid3X3,
  image: Image,
  layers: Layers,
  package: Package,
  printer: Printer,
  signpost: Signpost,
  shirt: Shirt,
  sofa: Sofa,
  sticker: Sticker,
  tent: Tent,
  wrench: Wrench,
};

export function CategoryIcon({ name, className }: { name: string; className?: string }) {
  const Icon = iconMap[name] || Grid3X3;
  return <Icon className={className} aria-hidden="true" />;
}
